module.exports = __webpack_public_path__ + "img/09_Imaginative Mind.783247dd.svg";